<template>
  <div class="car-detail-container">
    <h6 class="font-weight-bold"><img src="@/assets/fa/car-icon.svg" alt="" /><slot></slot></h6>
  </div>
</template>

<script>
export default {
  name: 'CarDetail',
};
</script>

<style scoped lang="scss">
h6 {
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin-bottom: 2px;
}
img {
  width: 36px;
  height: 36px;
  margin-right: 10px;
  margin-top: -4px;
}
</style>
